import React from "react";
import { ReactComponent as Sprite } from "../../assets/images/symbol-defs.svg";
const IconSprite = () => {
  return <Sprite />;
};

export default IconSprite;
